
import React, { useCallback, useEffect, useState } from 'react';
import { Form, Input, Radio, Select } from 'tdesign-react';

import { IFormItemProps } from '@/components';
import { fetchVoiceList } from '@/services/bot';

import styles from './index.module.less';


interface IFormArrayProps {
  fieldsConfig: IFormItemProps[];
  form: any;
  repeatConfig?: {
    [key: string]: IFormItemProps[];
  };
}

const { FormItem } = Form;

export const CustomVoiceSelect: React.FC<
{
  fieldname: string;
  config: any;
  errors: { [key: string]: any };
  getFieldDecorator: any;
  value: { voiceId: undefined, voiceType: 1 | 2 };
  max: number;
  onChange: (value: { voiceId: string | undefined, voiceType: 1 | 2 }) => {};
  disabled?: boolean;
} & IFormArrayProps
> = (props) => {
  const {
    value = { voiceId: undefined, voiceType: 1 },
    onChange,
    disabled = false,
  } = props;

  const [options, setOptions] = useState<{ value: string, label: string }[]>([]);

  const loadVoices = useCallback(async () => {
    const res = await fetchVoiceList();
    if (res) {
      setOptions(res.map(item => ({ label: item.voiceName || '未命名', value: item.voiceId.toString() })));
    }
  }, []);

  const handleValuesChange = useCallback((e: any) => {
    onChange({ ...value, ...e });
  }, [value]);

  useEffect(() => {
    loadVoices();
  }, []);

  return (
    <Form initialData={value} className={styles.arrayWrap} onValuesChange={handleValuesChange}>
      <FormItem name='voiceType' className={styles.item} labelAlign='top' label='语音包来源'>
        <Radio.Group options={[{ value: 1, label: 'CAI' }, { value: 2, label: '智影' }]}>
        </Radio.Group>
      </FormItem>
      <FormItem name='voiceId' className={styles.item} labelAlign='top' label='语音包'>
        {value.voiceType === 1 ? <Select
          disabled={disabled}
          options={options}
          value={value.voiceId}
        />
          : <Input
            value={value.voiceId}
            disabled={disabled}
          />}
      </FormItem>
    </Form>
  );
};
